import React, { useMemo } from 'react';
import {
  Colors,
  Flex,
  IconHeart,
  IconHeartFilled,
  Typography,
} from '@banhala/ui-kit';
import { useIsFavoriteMarket } from '../../hooks/useIsFavoriteMarket';
import { useGoodsDetail } from '../../queries/useGoodsDetail';
import { formatNumber, isNotNil } from 'shared/src/utils';
import { useOnPressFavoriteMarket } from '../../hooks/useOnPressFavoriteMarket';

export const MarketLikeView = () => {
  const { isFavoriteMarket } = useIsFavoriteMarket();
  const { data: goodsDetail } = useGoodsDetail();
  const { action } = useOnPressFavoriteMarket({
    sno: goodsDetail?.goods.market.sno,
    favorite: isFavoriteMarket,
  });

  const marketInfo = useMemo<{
    favoriteCount: string | null;
  }>(() => {
    if (isNotNil(goodsDetail)) {
      const countStr = formatNumber(
        goodsDetail.goods.market.score.favorites_count,
      );
      return {
        favoriteCount: `${countStr.value}${countStr.label}`,
      };
    }
    return {
      favoriteCount: null,
    };
  }, [goodsDetail]);

  return (
    <Flex.Row
      alignItems={'center'}
      gap={4}
      onPress={action}
      testID={`마켓즐겨찾기`}
      accessibilityState={{
        checked: isFavoriteMarket,
      }}
    >
      {isFavoriteMarket ? (
        <IconHeartFilled fill={Colors.content_pink_primary} size={20} />
      ) : (
        <IconHeart fill={Colors.content_pink_primary} size={20} />
      )}
      {isNotNil(marketInfo.favoriteCount) && (
        <Typography type={'body3'} color={'content_pink_primary'}>
          {marketInfo.favoriteCount}
        </Typography>
      )}
    </Flex.Row>
  );
};
